import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import EnquiryForm from "@/components/EnquiryForm";

export default function EnquiryDialog({ trigger, productName = "", productId = "", source = "PRODUCT_ENQUIRY", title = "Request Product Information" }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl" style={{ color: "#063B63" }}>{title}</DialogTitle>
          <DialogDescription>
            {productName ? `Enquiring about ${productName}. ` : ""}Enter your details and our technical team will get back to you.
          </DialogDescription>
        </DialogHeader>
        <EnquiryForm defaultProduct={productName} source={source} showQuantity onDone={() => {}} />
      </DialogContent>
    </Dialog>
  );
}
